import { createSelector } from 'reselect';

const getCollectionItems = ({ productDetails, queryParams }) => {
    const collections =
        productDetails && productDetails.collection ? productDetails.collection : [];
    const enrId = queryParams && queryParams.enrId ? queryParams.enrId : null;
    let selectedCollection;
    if (enrId) {
        const filteredCollection = collections.filter((collection) => collection.id === enrId)[0];
        selectedCollection = filteredCollection || collections[collections.length - 1];
    } else {
        selectedCollection = collections[collections.length - 1];
    }
    return {
        productDetails,
        selectedCollection,
    };
};

const getProductCollectionItems = createSelector(
    [getCollectionItems],
    ({ productDetails, selectedCollection }) => {
        const selectedCollectionProduct =
            selectedCollection &&
            Object.keys(selectedCollection).length &&
            selectedCollection.products
                ? selectedCollection.products
                : [];
        const currentProduct =
            productDetails && productDetails.id
                ? [
                      {
                          id: productDetails.base.id,
                          image:
                              productDetails.images &&
                              productDetails.images.filter((image) => image.type === 'PRIMARY')[0],
                      },
                  ]
                : [];
        const collectionItems = [...currentProduct, ...selectedCollectionProduct];
        collectionItems.forEach((item) => {
            let displayText = '';
            if (item.image) {
                displayText =
                    item.image.altText.length > 30
                        ? `${item.image.altText.substr(0, 30)}...`
                        : item.image.altText;
                item.image.displayText = displayText;
            }
        });
        return {
            collectionItems,
            selectedCollection,
        };
    }
);

export default getProductCollectionItems;
